import { BicycleCard, BicycleCardBottom } from "../../../../components"


export const BicycleCardsSection=()=>{
    
    


    return(
        <div className="bicyle-cards-section">
            <div className="row-1">
                <div className="row-1_bigger-item ">
                    <img  src={require('../../../../static/bicycle-logo.png')}/>
                </div>
                <BicycleCard/>
                <div>
                    <BicycleCardBottom/>
                    <div className="row_1-img">
                        <img src={require('../../../../static/seat-red.jpg')}/>
                    </div>
                </div>
            </div>
            <div className="row-2">
                <BicycleCard/>
                <div>
                    <BicycleCardBottom/>
                    <div className="row_2-img">
                        <img src={require('../../../../static/seat-black.jpg')}/>
                    </div>
                </div>
                <div className="row-2_bigger-item ">
                    <img  src={require('../../../../static/bicycle-logo.png')}/>
                </div>
            </div>
            <div className="row-3">
                <div className="row-3-img">
                    <img  src={require('../../../../static/red-frame.jpg')}/>
                </div>
                <div className="row-3_card">
                    <BicycleCard/>
                    <div className="row-3_card-images">
                        <BicycleCardBottom/>
                        <div className="row-3-img row-3_bottom-card">
                            <img src={require('../../../../static/chrome-wheels.jpg')}/>
                        </div>
                    </div>
                </div>
                
                <div className="row-3-img">
                    <img  src={require('../../../../static/red-bike.jpg')}/>
                </div>
            </div>
        </div>
    )
}